import { CartItem } from './../models/cart-item';
import * as React from 'react'; 

export class ElCartItem extends React.Component<CartItem, any> {

    constructor(props: CartItem) {
        super(props);
        this.state = { amount: props.product.numOfPkgs };
    }

    private onAmountChanged(e: any) {
        const val1 = parseInt(e.target.value);
        console.log('val changed', e, val1);
        if (!val1 || val1 < 0) {
            e.preventDefault();
            return;
        }
        this.props.onAmountChange(val1);
        this.setState({ amount: val1 });
    }
    
    render() {
        const total = this.props.product.price ? this.props.product.price * this.state.amount : 'по запросу'
        const jsx =
            <div className="row cart-item">
                <div className="col-sm-5">
                    <h3>{this.props.index}) {this.props.product.catNum}</h3>
                    <p>{this.props.product.title}</p>
                    <p>упаковка: {this.props.product.package}</p>
                </div>

                <div className="col-sm-2">{this.props.product.price ? this.props.product.price : 'по запросу'}</div>


                <div className="col-sm-2">
                    <input
                        type="number"
                        min="1"
                        value={this.state.amount}
                        onChange={this.onAmountChanged.bind(this)}

                        onInput={this.onAmountChanged.bind(this)}
                    />
                </div>

                <div className="col-sm-2">{this.props.product.price ? this.props.product.price * this.state.amount : 'по запросу'}</div>

                <div className="col-sm-1 cart-dlg-del-btn" onClick={() => this.props.onDelete(this.props.product)}>
                    <i className="far fa-trash-alt"></i>
                </div>
            </div>;
        return jsx;
    }
}